var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#3377FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 30H13C11.8954 30 11 29.1046 11 28V14C11 12.8954 11.8954 12 13 12H15V10H17V12H23V10H25V12H27C28.1046 12 29 12.8954 29 14V28C29 29.1046 28.1046 30 27 30ZM13 18V28H27V18H13ZM13 14V16H27V14H13ZM17.8 27H16V25.2L20.2 21.01L22 22.81L17.8 27ZM22.625 22.182L20.825 20.382L22.2 19.013L24 20.813L22.63 22.183L22.625 22.182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingSettings);
export default __webpack_public_path__ + "static/media/billingSettings.7de324ccca5ccba139de6cb65ea7a34a.svg";
export { ForwardRef as ReactComponent };